<template>
  <div class="DarkWhite pa-4">
      <v-row>
      <v-col cols="12" sm="6" md="8" lg="10">
        <h2 class="subheading green--text">Batched Stickers</h2>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-autocomplete
          v-model="fiscalYear"
          :items="fiscalyears"
          auto-select-first
          item-text="fiscalYear"
          item-value="fiscalYear"
          color="header"
          dense
          label="Year"
          class="mt-2"
        >
        </v-autocomplete>
      </v-col>
      </v-row>
      <Stickers :fiscalYear="fiscalYear" />
  </div>
</template>

<script>
  export default {
    components: {
      Stickers : () => import('../../components/Supply/Stickers.vue')
    },
    data: () => ({
      fiscalYear: null,
      fiscalyears: [],
    }),
    watch: {
      fiscalYear: {
      handler(data) {
        this.$store.dispatch("setYear", data);
      },
      deep: true,
    },
    },
    mounted(){
      this.getFiscalYears()
    },
    methods: {
      getFiscalYears() {
      this.axiosCall("/getAllFiscalYear", "GET").then((res) => {
        this.fiscalyears = [{id: 0, fiscalYear: "All"}, ...res.data.data]
        this.fiscalYear = this.$store.state.year != null ? this.$store.state.year : res.data.data[0].fiscalYear
      });
    },
    }
  }
</script>

<style scoped>
</style>